export default __webpack_public_path__ + "static/media/closeGrey.f7af68c7.svg";